import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  access: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  offset: 0,
  requestStatus: null,
};

export const accessSlice = createSlice({
  name: "access",
  initialState,
  reducers: {
    reducerGetAccess: (state: Draft<any>, action: PayloadAction<any>) => {
      state.access = action.payload.data;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    },
    reducerSetAccessRequestStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.requestStatus = action.payload;
    },
  },
});

export const { reducerGetAccess, reducerSetAccessRequestStatus } =
  accessSlice.actions;

export default accessSlice.reducer;
